export const LIST_GENERAL_CONFIGURATION_REQUEST = 'LIST_GENERAL_CONFIGURATION_REQUEST'
export const LIST_GENERAL_CONFIGURATION_SUCCESS = 'LIST_GENERAL_CONFIGURATION_SUCCESS'
export const LIST_GENERAL_CONFIGURATION_FAIL = 'LIST_GENERAL_CONFIGURATION_FAIL'

export const PATCH_GENERAL_CONFIGURATION_REQUEST = 'PATCH_GENERAL_CONFIGURATION_REQUEST'
export const PATCH_GENERAL_CONFIGURATION_SUCCESS = 'PATCH_GENERAL_CONFIGURATION_SUCCESS'
export const PATCH_GENERAL_CONFIGURATION_FAIL = 'PATCH_GENERAL_CONFIGURATION_FAIL'

export const DETAIL_GENERAL_CONFIGURATION_REQUEST = 'DETAIL_GENERAL_CONFIGURATION_REQUEST'
export const DETAIL_GENERAL_CONFIGURATION_SUCCESS = 'DETAIL_GENERAL_CONFIGURATION_SUCCESS'
export const DETAIL_GENERAL_CONFIGURATION_FAIL = 'DETAIL_GENERAL_CONFIGURATION_FAIL'
